import { Flex, Text, Button, FlexProps } from "@chakra-ui/react";

interface ServiceCardProps extends FlexProps {
  title: string;
  description: string;
  priceLabel: string;
  onAdd: () => void;
}

export const ServiceCard = ({
  title,
  description,
  priceLabel,
  onAdd,
  ...rest
}: ServiceCardProps) => {
  return (
    <Flex
      border="2px dashed #22C55E"
      borderRadius="16px"
      bg="#EBFFF1"
      p="14px"
      align={{ base: "stretch", md: "start" }}
      justify="space-between"
      direction={{ base: "column", md: "row" }}
      gap={{ base: "12px", md: "0" }}
      {...rest}
    >
      <Flex direction="column" gap="7px" flex="1">
        <Text fontSize="16px" fontWeight="600" color="#0B0E10">
          {title}
        </Text>
        <Text fontSize="14px" fontWeight="400" color="#505E70" lineHeight="1.5">
          {description}
        </Text>
      </Flex>

      <Button
        h="32px"
        p="4px 24px"
        borderRadius="100px"
        bg="transparent"
        color="#2563EB"
        fontSize="14px"
        fontWeight="500"
        border="1px solid #155EEF"
        _hover={{ bg: "#EBF5FF", }}
        _active={{ bg: "#155EEF", color: "#FFFFFF" }}
        onClick={onAdd}
        whiteSpace="nowrap"
        flexShrink={0}
      >
        {priceLabel}
      </Button>
    </Flex >
  );
};
